import * as types from '../mutation-types';
import {
    get_order_list,
    get_order_detail,
} from '@/api/order';

export const state = {
    orders: [],
    order: {},
    loading_order: false,
    loading: false,
    meta: {},
}
export const getters = {
    orders: state => state.orders,
    order: state => state.order,
    meta: state => state.meta,
    loading: state => state.loading,
}
export const mutations = {
    [types.ORDERS](state, payload) {
        state.loading = true;
    },
    [types.ORDERS_FAIL](state, payload) {
        state.loading = false;
        state.orders = [];
    },
    [types.ORDERS_SUCCESS](state, payload) {
        state.loading = false;
        state.orders = payload.items;
        state.meta = payload.meta;
    },

    [types.SALE_DETAIL](state, payload) {
        state.loading_order = true;
    },
    [types.SALE_DETAIL_FAIL](state, payload) {
        state.loading_order = false;
        state.order = [];
    },
    [types.SALE_DETAIL_SUCCESS](state, payload) {
        state.loading_order = false;
        state.order = payload;
    },

}
export const actions = {
    async getOrders({
        commit,
        getters
    }, payload) {
        commit(types.ORDERS);
        try {
            const data = await get_order_list(payload);
            commit(types.ORDERS_SUCCESS, data);
        } catch (error) {
            commit(types.ORDERS_FAIL);
        }
    },
    async getOrderDetail({
        commit,
        getters
    }, payload) {
        commit(types.SALE_DETAIL);
        try {
            const data = await get_order_detail(payload);
            commit(types.SALE_DETAIL_SUCCESS, data);
        } catch (error) {
            commit(types.SALE_DETAIL_FAIL);
        }
    },
}